import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import VideoSection from '@/pages/home/components/VideoSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import DailyArticles from '@/pages/home/components/DailyArticles';
import HotComments from '@/pages/home/components/HotComments';
import AppDownloadCTA from '@/pages/home/components/AppDownloadCTA';
import {
  navCategories,
  heroArticles,
  heiliaoVideos,
  featuredArticles,
  dailyArticles,
  hotComments,
  stats,
} from '@/mocks/home';

export default function Home() {
  return (
    <>
      <Navbar categories={navCategories} />
      <main>
        <HeroSection categories={navCategories} articles={heroArticles} />
        <VideoSection videos={heiliaoVideos} />
        <FeaturedSection articles={featuredArticles} />
        <DailyArticles articles={dailyArticles} />
        <HotComments comments={hotComments} statsData={stats} />
        <AppDownloadCTA />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '今日看料 - 全网吃瓜第一入口',
            description:
              '今日看料官网入口聚合页，涵盖黑料今日、网红塌房、明星私聊记录泄露等吃瓜内容，每日持续更新。',
            url: 'http://hlw51.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '今日看料',
              url: 'http://hlw51.cn/',
            },
            about: {
              '@type': 'Organization',
              name: '今日看料',
              url: 'http://hlw51.cn/',
              description:
                '今日看料是一个专注于娱乐八卦、网红爆料、明星黑料的吃瓜内容聚合平台。',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://hlw51.cn/',
                },
              ],
            },
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: dailyArticles.map((article, idx) => ({
                '@type': 'ListItem',
                position: idx + 1,
                item: {
                  '@type': 'Article',
                  name: article.title,
                  url: `http://hlw51.cn/article/${article.slug}`,
                  headline: article.title,
                  description: article.excerpt,
                  datePublished: article.date,
                },
              })),
            },
          }),
        }}
      />
    </>
  );
}